export class LoadProjectError extends Error {}
